//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { LABEL_MARKS } from './RequestWorkTypes.js'
import RequestWorkPackageGroupInclusionMode from './RequestWorkPackageGroupInclusionMode.vue'

export default {
  name: 'RequestWorkPackageListElement',
  components: {
    RequestWorkPackageGroupInclusionMode
  },
  props: {
    workPackage: {
      type: Object,
      required: true
    },
    request: {
      type: Object,
      required: true
    },
    editable: {
      type: Boolean,
      default: true
    },
    hideDeleteBtn: {
      type: Boolean,
      default: false
    },
    hideIndicators: {
      type: Boolean,
      default: false
    },
    isNotSaved: {
      type: Boolean,
      default: false
    },
    engineerView: {
      type: Boolean,
      default: false
    },
    isAdditionalDeparture: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      workPackageMark: LABEL_MARKS.workPackage
    }
  },
  computed: {
    showDeleteBtn: function () {
      return this.editable && (!this.hideDeleteBtn && !this.workPackage.hasAnyDoneReports || this.isNotSaved)
    }
  },
  methods: {
    onDeleteWorkPackage: function (event) {
      this.$emit('delete', this.workPackage)
    }
  }
}
